import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type { GetAttendanceSummaryDailyPlaceListItem } from './attendance-api-types';

// 共通の型定義
type AttendanceTablePersonColumn = {
  id: string;
  avatarUrl?: string;
  name: string;
  email?: string;
  linkTo: string;
};

type AttendanceTableClockInColumn =
  GetAttendanceSummaryDailyPlaceListItem['clockIns'][number];
type AttendanceTableClockOutColumn =
  GetAttendanceSummaryDailyPlaceListItem['clockOuts'][number];
type AttendanceTableRestTimeColumn = {
  totalRestTimeMinutes: number;
  restTimes: GetAttendanceSummaryDailyPlaceListItem['restTimes'][number][];
  isEdited: boolean;
  editReason?: string;
};

// 共通のカラム定義
export const AttendanceTableColumns = {
  PERSON: 'person',
  DATE: 'date',
  CLOCK_INS: 'clockIns',
  CLOCK_OUTS: 'clockOuts',
  TOTAL_WORKING_TIME_MINUTES: 'totalWorkingTimeMinutes',
  REST_TIMES: 'restTimes',
  IS_VALID: 'isValid',
  ERRORS: 'errors',
} as const;

export type AttendanceTableColumns = EnumUnion<typeof AttendanceTableColumns>;

// 共通の行の型定義
export type AttendanceTableRow = {
  [AttendanceTableColumns.PERSON]?: AttendanceTablePersonColumn;
  [AttendanceTableColumns.DATE]: Date;
  [AttendanceTableColumns.CLOCK_INS]: AttendanceTableClockInColumn[];
  [AttendanceTableColumns.CLOCK_OUTS]: AttendanceTableClockOutColumn[];
  [AttendanceTableColumns.REST_TIMES]: AttendanceTableRestTimeColumn;
  [AttendanceTableColumns.TOTAL_WORKING_TIME_MINUTES]: number;
  [AttendanceTableColumns.IS_VALID]: boolean;
  [AttendanceTableColumns.ERRORS]: string[];
};

// 日次・場所別テーブル用の型
export type AttendanceDailyPlaceTableRow = AttendanceTableRow;

// 月次・人物別テーブル用の型
export type AttendanceMonthlyPersonTableRow = AttendanceTableRow & {
  [AttendanceTableColumns.DATE]: Date;
};

const MonthlyPlaceTableColumns = {
  PERSON: 'person',
  WORKING_DAYS: 'workingDays',
  TOTAL_WORKING_TIME: 'totalWorkingTime',
  ERROR_COUNT: 'errorCount',
} as const;

export type MonthlyPlaceTableColumns = EnumUnion<
  typeof MonthlyPlaceTableColumns
>;

export type MonthlyPlaceTableRow = {
  [MonthlyPlaceTableColumns.PERSON]: {
    id: string;
    name: string;
    avatarUrl?: string;
    linkTo: string;
  };
  [MonthlyPlaceTableColumns.WORKING_DAYS]: number;
  [MonthlyPlaceTableColumns.TOTAL_WORKING_TIME]: number;
  [MonthlyPlaceTableColumns.ERROR_COUNT]: number;
};
